import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Grid of category banners.
 *
 * `level` decides how deep each tile links. The homepage renders L2 as circles
 * already, so this grid is given L3 there — otherwise both sections showed the
 * identical five categories under two different headings.
 */
const Level2BannerGrid = ({ banners, level1Category, level = 2 }) => {
  if (!banners || banners.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-400 text-sm">No categories available</p>
      </div>
    );
  }

  const tileFor = (banner) => {
    const l1 = encodeURIComponent(banner.categoryLevel1 || level1Category || '');
    const l2 = encodeURIComponent(banner.categoryLevel2 || '');

    if (level >= 3 && banner.categoryLevel3) {
      return {
        to: `/user/browse/${l1}/${l2}/${encodeURIComponent(banner.categoryLevel3)}`,
        label: banner.categoryLevel3
      };
    }
    return {
      to: `/user/browse/${l1}/${l2}`,
      label: banner.categoryLevel2 || banner.title
    };
  };

  return (
    <div className="grid grid-cols-4 gap-2">
      {banners.map((banner, idx) => {
        const { to, label } = tileFor(banner);
        return (
          <Link key={banner._id || `banner-${idx}`} to={to} className="block">
            <div className="relative aspect-square overflow-hidden rounded-lg bg-gray-100">
              {banner.imageUrl ? (
                <img
                  src={banner.imageUrl}
                  alt={label}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              ) : (
                <div className="w-full h-full bg-gradient-to-br from-gray-200 to-gray-300" />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-1.5">
                <p className="text-[10px] font-semibold text-white text-center line-clamp-2 leading-tight">
                  {label}
                </p>
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default Level2BannerGrid;
